import { validate } from "../../utils/validate"

/**
 * @dtsModule max.cache
 * @dtsNamespace cache
 * @dtsDesc cache Storage
 */
export const cache = {
  /**
   * @dtsExport
   * Get cache data for a specified key
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.cache.get&lang=%{locale}%)
   */
  get(key: string): string {
    try {
      validate.String(key, "key")
      return JSON.parse(sessionStorage.getItem(key))
    } catch (e) {
      throw Error(e)
    }
  },
  /**
   * @dtsExport
   * Set cache data for a specified key
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.cache.set&lang=%{locale}%)
   */
  set(key: string, value: string | number | boolean): string | number | boolean {
    try {
      validate.String(key, "key")
      sessionStorage.setItem(key, JSON.stringify(value))
      return true
    } catch (e) {
      throw Error(e)
    }
  },
  /**
   * @dtsExport
   * Remove cache data for a specified key
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.cache.remove&lang=%{locale}%)
   */
  remove(key: string): boolean {
    try {
      validate.String(key, "key")
      sessionStorage.removeItem(key)
      return true
    } catch (e) {
      throw Error(e)
    }
  },
  /**
   * @dtsExport
   * Clear cache data for a specified key
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.cache.clear&lang=%{locale}%)
   */
  clear(): boolean {
    try {
      sessionStorage.clear()
      return true
    } catch (e) {
      throw Error(e)
    }
  },
}
